__webpack_require__.p = "/hxbingo/";